import { Icon } from "icons";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { useDebouncedInput, parseNullableString } from "./useDebouncedInput";
import { useGroupUpdate } from "./useGroupUpdate";

interface FreestyleHeaderFieldsProps {
  workoutItemId: string;
}

export const FreestyleHeaderFields = observer(function FreestyleHeaderFields(
  props: FreestyleHeaderFieldsProps,
) {
  const { t } = useTranslation();
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getGroupWorkoutItemById(
    props.workoutItemId,
  );
  const { handleUpdate } = useGroupUpdate(props.workoutItemId);

  const { localValue, handleChange } = useDebouncedInput({
    initialValue: workoutItem.mediaUrl ?? "",
    onChange: (value) => {
      handleUpdate({ mediaUrl: value });
    },
    transform: parseNullableString,
  });

  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <div
      className="flex items-center gap-2 shrink-0"
      onClick={handleStopPropagation}
    >
      <Icon name="tabler-link" className="h-4 w-4 text-slate-400 shrink-0" />
      <Input
        type="url"
        value={localValue}
        onChange={handleChange}
        placeholder={t("editWorkout.mediaUrlPlaceholder")}
        className="h-7 w-[180px] text-sm bg-white/80 border-slate-200"
      />
    </div>
  );
});
